/*** IMPORTS FROM imports-loader ***/


module.exports = {
    title: "Hercules Magnus",
    theme: "hm",
    baseMultiplier: 0.5,
    maxPrize: 8,

    font: "ProximaNova",
    fontVariations: ":n4,n7",
    secondaryFont: "SignPainter",

    hasPrizeAnimations: true,
    hasMultiAnimations: true,

    hasButtonImage: true,
    blurMenuBg: false,
    bigWinStartingPrizeId: 5,

    backgroundAnchorX: 0,
    backgroundAnchorY: 0.5,

    hasMultiplier: true,
    hasBackgroundView: true,

    donePercent: 60,
    brushSize: 100,
    scratchY: 30,
    prizeScale: 1,
    prizeTextY: 23,

    showLogoInGame: false,
    logoYInGame: 10,
    logoYTitle: 400,
    logoZTitle: 3,
    logoFromBottomTitle: true,

    showCharacter: true,
    characterX: 40,
    characterY: 440,
    characterZ: 1,
    characterScale: 1.8,

    showFog: false,
    showBottomGradient: false,

    ticketIdX: 5,

    titleLossY: 170,

    winSign: 'image',
    winSignTextY: 15,
    winSignTextMaxWidth: 220,
    winSignTextMaxFontSize: 40,
    winSignYOffset: 5,

    bgColor: 0x5a6b65,
    primaryColor: 0xfcb62e,

    images: {

        brush: "brush.png",

        bgs: {
            scratched: "scratch_bg.png",
            unscratched: "scratch.png"
        },

        prizes: {
            1: "1|1", // 0.25
            2: "1|2", // 0.50
            3: "2|1", // 0.50
            4: "1|3", // 0.75
            5: "2|2", // 1.00
            6: "3|1", // 1.00
            7: "1|5", // 1.25
            8: "2|3", // 1.50
            9: "3|2", // 2.00
            10: "1|10", // 2.50
            11: "2|5", // 2.50
            12: "4|1", // 2.50
            13: "3|3", // 3.00
            14: "2|10", // 5.00
            15: "3|5", // 5.00
            16: "4|2", // 5.00
            17: "5|1", // 5.00
            18: "4|3", // 7.50
            19: "3|10", // 10.00
            20: "5|2", // 10.00
            21: "6|1", // 10.00
            22: "4|5", // 12.50
            23: "5|3", // 15.00
            24: "6|2", // 20.00
            25: "4|10", // 25.00
            26: "5|5", // 25.00
            27: "7|1", // 25.00
            28: "6|3", // 30.00
            29: "5|10", // 50.00
            30: "6|5", // 50.00
            31: "7|2", // 50.00
            32: "7|3", // 75.00
            33: "6|10", // 100.00
            34: "7|5", // 125.00
            35: "7|10", // 250.00
            36: "8|1", // 250.00
            37: "8|2", // 500.00
            38: "8|3", // 750.00
            39: "8|5", // 1250.00
            40: "8|10", // 2500.00
            41: "9|1", // 5000.00
            42: "9|2", // 10000.00
            43: "9|3", // 15000.00
            44: "9|5", // 25000.00
            45: "9|10" // 50000.00
        }
    },

    sounds: {
        volumes: {
            click: 0.3,
            music: 0.08,
            reveal: 0.5,
            bigWin: 0.4,
            win: 0.4,
            loss: 0.4
        },
        prizes: {
            1: "win-2",
            2: "win-2",
            3: "win-2",
            4: "win-2",
            5: "win-2",
            6: "win-2",
            7: "win-2",
            8: "win-2",
            9: "win-2",
            10: "win-2",
            11: "win-3",
            12: "win-3",
            13: "win-3",
            14: "win-3",
            15: "win-3",
            16: "win-3",
            17: "win-3",
            18: "win-3",
            19: "win-3",
            20: "win-4",
            21: "win-4",
            22: "win-4",
            23: "win-4",
            24: "win-4",
            25: "win-4",
            26: "win-4",
            27: "win-4",
            28: "win-4",
            29: "win-4",
            30: "win-4",
            31: "win-4",
            32: "win-4",
            33: "win-4",
            34: "win-4",
            35: "win-4",
            36: "win-4",
            37: "win-4",
            38: "win-4",
            39: "win-4",
            40: "win-4",
            41: "win-4",
            42: "win-4",
            43: "win-4",
            44: "win-4",
            45: "win-4"
        }
    },

    styles: {
        prize: {
            fontFamily: "ProximaNova",
            fontSize: 17,
            fontWeight: 100,
            fill: "#FEE9FF",
            align: "center",
            lineHeight: 25,
            stroke: '#0F0E33',
            strokeThickness: 2,
            dropShadow: true ,
            dropShadowColor: '#000000',
            dropShadowAngle: Math.PI/2 ,
            dropShadowDistance: 1
        },
        maxPrize: {
            fontFamily: "ProximaNova",
            fontSize: 17,
            fontWeight: 100,
            fill: "#D9C82C",
            align: "center",
            lineHeight: 25,
            stroke: '#0F0E33',
            strokeThickness: 2,
            dropShadow: true ,
            dropShadowColor: '#000000',
            dropShadowAngle: Math.PI/2 ,
            dropShadowDistance: 1
        },
        introText: {
            fontFamily: "ProximaNova",
            fontSize: 16,
            fontWeight: 100,
            fill: "#FFFFFF",
            align: "center",
            lineHeight: 23,
            wordWrap: true,
            wordWrapWidth: 260,
            stroke: '#3F082D',
            strokeThickness: 3,
            lineJoin: 'round',
            dropShadow: false,
            dropShadowBlur: 3,
            dropShadowColor: '#000000',
            dropShadowAngle: Math.PI/2,
            dropShadowDistance: 2
        }
    },

    positions: {
        points:[
            {
                x:0.22,
                y:0.19
            },
            {
                x:0.50,
                y:0.19
            },
            {
                x:0.78,
                y:0.19
            },
            {
                x:0.22,
                y:0.425
            },
            {
                x:0.50,
                y:0.425
            },
            {
                x:0.78,
                y:0.425
            },
            {
                x:0.22,
                y:0.66
            },
            {
                x:0.50,
                y:0.66
            },
            {
                x:0.78,
                y:0.66
            }
        ],
        multiplier:{
            x:0.50,
            y:0.87
        }
    }
};




//////////////////
// WEBPACK FOOTER
// ./themes/hm/config.js
// module id = 50
// module chunks = 4